import React from "react";

import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  Divider,
} from "@tiny/components";
import { SuppressionItemInfoView } from "@tiny/api";
import TrashFull from "@tiny/icons/generated/TrashFull";
import { useDeleteSuppressionDetailsDialog } from "./DeleteSuppressionDetailsDialog.hooks";
import DeleteSuppressionDetailsRow from "./DeleteSuppressionDetailsRow";

export interface DeleteSuppressionDetailsDialogProps {
  open: boolean;
  suppressions: SuppressionItemInfoView[];
  onClose: () => void;
  onSuccess: () => void;
  suppressionId?: string;
}

function DeleteSuppressionDetailsDialog(
  props: DeleteSuppressionDetailsDialogProps
) {
  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DeleteSuppressionDetailsDialogContent {...props} />
    </Dialog>
  );
}

function DeleteSuppressionDetailsDialogContent(
  props: DeleteSuppressionDetailsDialogProps
) {
  const { onClose, suppressions } = props;

  const { deleteSuppressions, deleting } =
    useDeleteSuppressionDetailsDialog(props);

  return (
    <>
      <DialogTitle onClose={onClose}>
        Delete Item
        {suppressions.length > 1 ? "s" : ""}?
      </DialogTitle>
      <DialogContent>
        <List>
          <Divider />
          {suppressions.map((item) => (
            <DeleteSuppressionDetailsRow key={item.id} item={item} />
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="red"
          onClick={deleteSuppressions}
          endIcon={<TrashFull />}
          loading={deleting}
          disabled={deleting}
        >
          Delete
        </Button>
      </DialogActions>
    </>
  );
}

export default DeleteSuppressionDetailsDialog;
